module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAYCAYAAAAh8HdUAAAACXBIWXMAABYlAAAWJQFJUiTwAAAA6UlEQVQ4jZ3UsRGCMBTG8Q+p7BhBO0stX+coboBhAWQBIhswCh0p3QBGoLT0wgUPyXs5MAWF4Z/fAe+MIKxMqQeAnNlt2ChTKgHQAUiY7ctOgO5CUJdav7woU+oAIBUOK+yFk/KA0nuRU24hhZO4tzUGk/ITBZQBwHP+w1ySlKrUevCiLcpcWq3YFTmlY4K+1PrInSRNRHDFrTEDEVntvLgxIaKoNaaRpEI4OXXD60fuw9VMlLjhFZ9ptfaNtmjLtydpufs0fhTQxlCSJs2bAjtmk+ZFTqtC2l9/LDEXtca8iWgP4OptAqcPZVJQZuBElsMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/img/48.png
// module id = TF6W
// module chunks = 1